module.exports = __webpack_public_path__ + "img/failed.55d42b61.png";